import request from "@/utils/request";
import requestOMS from "@/utils/oms-request"
import { ICustomerModel } from "./types";

export const defaultCustomerData: ICustomerModel = {
  id: null,              //用户id
  code: null,          //客户编号
  name: null,              //BL公司名
  abbreviation: null,  //客户简称
  customerAddress: null,     //BL公司地址
  tel: null,      //BL公司其他信息
  nation: null, // 客人国家
  country: null, //原产国
  departures: null, //出口港
  tradeCountry: null,   //贸易国
  departure: null,  //出境关别
  transportation: null,  //运输方式
  destinationCountry: null, //最终目的国
  deliveryCountry: null, //运抵国
  portDischarge: null, //指运港
  internationalTradeTerms: null, //成交方式
  payment: null, //付款方式
  paymentDetails: null,//付款方式详情
  ladingType: null, //提单类型
  notifier: null, //BL公司其他信息
  notifierAddress: null, //BL通知人地址
  address: null,
  fivePiecesSetCompanyName: null, // 五件套公司名
  fivePiecesSetCompanyAddress: null, // 五件套公司地址
  fivePiecesSetCompanyOtherInfo: null, // 五件套公司其他信息
};


export const getCustomer = (code: string):Object =>
  request({
    url: `/customers/${code}`,
    method: "get"
  });

export const getCustomerAllInfo = (code: string):Object =>
  request({
    url: `/customers/${code}/all-info`,
    method: "get"
  });

export const getCustomerEdit = (code: string):Object =>
  request({
    url: `/customers/${code}/edit`,
    method: "get"
  });

export const createCustomerSimple = (data: { name: string, code: string, abbreviation?: string }) =>
  request({
    url: `/customers/in/storage`,
    method: "post",
    data
  });

export const createCustomerWhole = (data: any) =>
  request({
    url: `/customers/in/shipping`,
    method: "post",
    data
  });

export const searchCustomer = (params: { keyword: string }) =>
  request({
    url: `/customers`,
    method: "GET",
    params
  });

export const searchAllCustomer = (params: { keyword: string }) =>
    request({
        url: `/customers/search-all`,
        method: "GET",
        params
    });

export const searchPaymentName = (params: { keyword: string }) =>
  request({
    url: `/customers/payment-name`,
    method: "GET",
    params
  });

export const searchCustomerAll = (params: any) =>
    request({
        url: "/customers/all",
        method: "GET",
        params,
    });

export const searchCustomsProductInfo = (params: any) =>
    request({
        url: "/customers-product-infos",
        method: "get",
        timeout: 600000,
        params,
    })

export const deleteCustomer = (id: string) =>
    request({
        url: `/customers/${id}`,
        method: "delete",
    })

export const uploadCustomer = (data: FormData) =>
    request({
        headers: {"Content-Type": "multipart/form-data"},
        url: "/customers/excel",
        method: "post",
        data: data
    });

export const uploadCustomerPriceClass = (data: FormData) =>
    request({
        headers: {"Content-Type": "multipart/form-data"},
        url: "/customers/price-class/excel",
        method: "post",
        data: data
    });


export const getAmountDistributionList = (params: any) =>
    requestOMS({
        url: "/payment_voucher/deposit-payment-voucher/amount-distribution",
        method: "get",
        params,
    });
export const saveAmountDistributionList = (params: any, data: any) =>
    requestOMS({
        url: "/payment_voucher/deposit-payment-voucher/amount-distribution",
        method: "post",
        params,
        data,
    });
    // /customers/{id}/payment-info
    // 请求对应的汇款人信息
export const getPaymentInfo = (id) =>
    request({
        url: `/customers/${id}/payment-info`,
        method: "get"
    });
    // /customers/{id}/base-info
    // 请求对应的客人信息
export const getBaseInfo = (id) =>
    request({
        url: `/customers/${id}/base-info`,
        method: "get"
    });

// /customer-inventory/customers/{id}
// 查看所有库存列表
export const getCustomersKCList = (id,params) =>
    requestOMS({
        url: `/customer-inventory/customers/${id}`,
        method: "get",
        params
    });

//查询号码单据信息
export const queryTheNumberBilInfo = (params) =>
  requestOMS({
    url: `/product_numbers/units/document-info`,
    method: "get",
    params
  })

//查询无法删除的号码
export const getnotDeleteNumber = (params:any) =>
  requestOMS({
    url: `/product_numbers/units/number-info`,
    method: "get",
    params
  })
//删除号码
export const deleteModelNumber = (params:any) =>
  requestOMS({
    url: `/product_numbers/units/document-info`,
    method: "delete",
    params
  })


export const getAllPriceClass = () =>
    request({
        url: `/customers/price-class/all`,
        method: "get",
    })